import { transformContentServicesForModelInterpretation } from '../Helpers';

class Base {

  constructor(props = {}, contentServices = []) {
    const content = contentServices?.[0];
    const data = !content ? props : transformContentServicesForModelInterpretation(content);
    this._props = data || {};
  }

  get(key, defaultsTo) {
    let prop = this._props[key];
    if (prop) return prop;

    prop = defaultsTo;
    return prop;
  }

  toJSON() {
    return this._props;
  }
}

export default Base;
